export enum CircleType {
  LEFT_CIRCLE,
  TOP_CIRCLE,
  BOTTOM_CIRCLE,
  RIGHT_CIRCLE,
}
